// SVG paths copied from original getMobilePropertyIcon.
const icons: Record<string, string> = {
  smoothing:
    '<path d="M3 17C6 17 6 7 12 7s6 10 9 10" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>',
  "plus-image":
    '<path d="M3 4h13v2H5v12h12v-7h2v9H3V4zm5 10 2.5-3 2 2.4 1.5-1.9 3 4.5H7l1-2zm11-12v3h3v2h-3v3h-2V7h-3V5h3V2h2z"/>',
  id: '<path d="M4 4h16v16H4V4zm2 2v12h12V6H6zm2 2h3v3H8V8zm5 0h3v2h-3V8zm-5 5h8v2H8v-2z"/>',
  text: '<path d="M4 4h16v4h-2V6h-5v12h3v2H8v-2h3V6H6v2H4V4z"/>',
  correct: '<path d="m9 16.2-4.2-4.2-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>',
  target:
    '<path d="M12 3a9 9 0 1 0 9 9h-2a7 7 0 1 1-7-7V3zm0 4a5 5 0 1 0 5 5h-2a3 3 0 1 1-3-3V7zm5-4v3h-3v2h3v3h2V8h3V6h-3V3h-2z"/>',
  screen: '<path d="M3 4h18v14H3V4zm2 2v10h14V6H5zm4 13h6v2H9v-2z"/>',
  score:
    '<path d="m12 3 2.3 4.7 5.2.8-3.8 3.7.9 5.2-4.6-2.5-4.6 2.5.9-5.2-3.8-3.7 5.2-.8L12 3z"/>',
  visible:
    '<path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12zm2.5 0s2.7 4 7.5 4 7.5-4 7.5-4S16.8 8 12 8s-7.5 4-7.5 4zm7.5-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/>',
  motion: '<path d="M4 6h11V3l5 4-5 4V8H4V6zm16 12H9v3l-5-4 5-4v3h11v2z"/>',
  deform:
    '<path fill="#7c3aed" d="M5 4h5v2H7v3H5V4zm9 0h5v5h-2V6h-3V4zM5 15h2v3h3v2H5v-5zm12 0h2v5h-5v-2h3v-3z"/><path fill="#c4b5fd" d="m9 9 6-1 1 7-7 1V9zm2 2v3l3-.4-.4-3-2.6.4z"/>',
  hue: '<path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 2a8 8 0 0 1 6.9 4H12V4zm-2 .3V11L4.2 7.7A8 8 0 0 1 10 4.3zM3.2 9.5 9 12.8l-5.8 3.3A8 8 0 0 1 3.2 9.5zM10 19.7a8 8 0 0 1-5.8-3.4L10 13v6.7zm2 .3v-6h6.9a8 8 0 0 1-6.9 6zm1.2-8 5.7-3.3a8 8 0 0 1 0 6.6L13.2 12z"/>',
  cutout:
    '<path d="M4 4h5v2H6v3H4V4zm11 0h5v5h-2V6h-3V4zM4 15h2v3h3v2H4v-5zm14 0h2v5h-5v-2h3v-3zM12 7a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm-5 9c.9-2 2.6-3 5-3s4.1 1 5 3H7z"/>',
  shadow:
    '<path d="M5 4h12v12H5V4zm2 2v8h8V6H7zm3 12h9v2h-9v-2zm8-9h2v8h-2V9z"/>',
  merge:
    '<path d="M3 4h8v7H3V4zm2 2v3h4V6H5zm8 7h8v7h-8v-7zm2 2v3h4v-3h-4zM8 13h3v-2h2v3a1 1 0 0 1-1 1H8v2l-4-3 4-3v2zm8-6h-3V9h-2V6a1 1 0 0 1 1-1h4V3l4 3-4 3V7z"/>',
  confirm:
    '<path d="m9.2 16.2-4.4-4.4L3.4 13.2 9.2 19 21 7.2l-1.4-1.4-10.4 10.4z"/>',
  cancel:
    '<path d="m6.4 5 5.6 5.6L17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6L6.4 19 5 17.6l5.6-5.6L5 6.4z"/>',
  font: '<path d="M5 4h14v3h-2l-.4-1H13v12h2v2H9v-2h2V6H7.4L7 7H5V4z"/>',
  "font-size":
    '<path d="M3 5h12v3h-2l-.4-1H10v11h2v2H5v-2h2V7H4.4L4 8H3V5zm12 7h6v2h-2v4h1v2h-4v-2h1v-4h-2v-2z"/>',
  fill: '<path d="m7 3 10 10-6 6a3 3 0 0 1-4.2 0l-2.8-2.8a3 3 0 0 1 0-4.2l6-6-3-3zm3.5 5L5.4 13a1 1 0 0 0 0 1.4l2.8 2.8a1 1 0 0 0 1.4 0l5.1-5.1L10.5 8zM18 14s3 3.1 3 5a3 3 0 0 1-6 0c0-1.9 3-5 3-5z"/>',
  "line-spacing":
    '<path d="M8 5h13v2H8V5zm0 6h13v2H8v-2zm0 6h13v2H8v-2zM4 4l3 3H5v10h2l-3 3-3-3h2V7H1l3-3z"/>',
  "letter-spacing":
    '<path d="M7 5h4v2H9v10h2v2H5v-2h2V7H5V5h2zm10 0h4v2h-1.3l-3.2 12h-2L11.3 7H10V5h4v2h-.7l2.2 8.5L17.7 7H17V5zM2 21l3-3v2h14v-2l3 3-3 3v-2H5v2l-3-3z"/>',
  "align-left":
    '<path d="M4 5h16v2H4V5zm0 4h10v2H4V9zm0 4h16v2H4v-2zm0 4h10v2H4v-2z"/>',
  "align-center":
    '<path d="M4 5h16v2H4V5zm3 4h10v2H7V9zm-3 4h16v2H4v-2zm3 4h10v2H7v-2z"/>',
  "align-right":
    '<path d="M4 5h16v2H4V5zm6 4h10v2H10V9zm-6 4h16v2H4v-2zm6 4h10v2H10v-2z"/>',
  bold: '<path d="M7 4h7a4 4 0 0 1 2.5 7.1A4.5 4.5 0 0 1 14 20H7V4zm3 2v4h4a2 2 0 0 0 0-4h-4zm0 6v6h4a3 3 0 0 0 0-6h-4z"/>',
  italic: '<path d="M9 4h9v2h-3l-4 12h3v2H5v-2h3l4-12H9V4z"/>',
  underline:
    '<path d="M7 3h2v8a3 3 0 0 0 6 0V3h2v8a5 5 0 0 1-10 0V3zm-2 16h14v2H5v-2z"/>',
  "stroke-width": '<path d="M4 5h16v1H4V5zm0 4h16v2H4V9zm0 6h16v4H4v-4z"/>',
  color:
    '<path d="M12 3a9 9 0 1 0 0 18c1.7 0 2.7-.9 2.7-2.2 0-.7-.3-1.2-.6-1.7-.2-.4-.3-.7-.3-1 0-.8.6-1.4 1.5-1.4H17a4 4 0 0 0 4-4C21 6.3 17 3 12 3zM7.5 12A1.5 1.5 0 1 1 7.5 9a1.5 1.5 0 0 1 0 3zm3-4A1.5 1.5 0 1 1 10.5 5a1.5 1.5 0 0 1 0 3zm4 0A1.5 1.5 0 1 1 14.5 5a1.5 1.5 0 0 1 0 3zm3 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>',
  blur: '<path d="M12 9.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM6.5 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM3 10.8a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4zm18 0a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4z"/>',
  cut: '<path d="M8 3a4 4 0 1 0 1.4 7.7L12 13.3l-2.6 2.6A4 4 0 1 0 11 17.5l2.4-2.4 6.2 6.2 1.4-1.4-7.6-7.6 7.6-7.6-1.4-1.4-7.6 7.6-2.6-2.6A4 4 0 0 0 8 3zM6 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/>',
  copy: '<path d="M8 8h12v12H8V8zm2 2v8h8v-8h-8zM4 4h12v2H6v10H4V4z"/>',
  delete: '<path d="M7 8h10l-1 13H8L7 8zm2-4h6l1 2h4v2H4V6h4l1-2z"/>',
  enclosed:
    '<path d="M4 4h16v16H4V4zm2 2v12h12V6H6zm3 3h6v6H9V9zm2 2v2h2v-2h-2z"/>',
  dashed: '<path d="M3 11h4v2H3v-2zm7 0h4v2h-4v-2zm7 0h4v2h-4v-2z"/>',
};
export function originalIcon(name: string) {
  return `<svg data-original-icon="${name}" viewBox="0 0 24 24" aria-hidden="true">${icons[name] ?? ""}</svg>`;
}
